import React, { Component } from 'react';
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';

import { WorkOrder } from './WorkOrder';
import { WorkOrderInt } from './WorkOrderInt';
import { Client } from './Client';
import { Interpreter } from './Interpreter';
import { Rep } from './Rep';
import { ProviderOffice } from './ProviderOffice';
import { Rolodex } from './Rolodex';
import { Claimant } from './Claimant';
import { PostChecks } from './PostChecks';
import { InterpreterPayment } from './InterpreterPayment';
import { PrintInvoice } from './PrintInvoice';
import { InterpreterAvailabilityAdmin } from './InterpreterAvailabilityAdmin';
import { InterpreterSignUps } from './InterpreterSignUps';
import { BulkTransfer } from './BulkTransfer';
import { TransferCash } from './TransferCash';
import { LateInvoices } from './LateInvoices';
import { AccountsReceivable } from './AccountsReceivable';
import { BusinessCards } from './BusinessCards';
import { RptProduction } from './Reports/RptProduction';
import { RptClientInvoiceSummary } from './Reports/RptClientInvoiceSummary';
import { RptAccountsReceivable } from './Reports/RptAccountsReceivable';
import { RptChecksReceived } from './Reports/RptChecksReceived';
import { RptInterpreter1099 } from './Reports/RptInterpreter1099';
import { RptRepCount } from './Reports/RptRepCount';
import { RptClientSummary } from './Reports/RptClientSummary';
import { User } from './User';
import { TimeOff } from './TimeOff';
import { GetCookie, GetParameterByName } from './utils/Common';
import RemoveIcon from '../images/remove-icon.png';
import Cookies from 'js-cookie';
import { FetchData } from './utils/DataFetch';
import { RptTransportationSummary } from './Reports/RptTransportationSummary';
import { RptMarketReportSummary } from './Reports/RptMarketReportSummary';
import { TroubleTicket } from './TroubleTicket';
import { Translation } from './Translation';

const hidePiggybackViews = new Set([
  'Work Order',
  'Booking',
  'Auth/Transport',
  'Confirmation',
  'Remote Jobs',
  'PurpleReport',
  'Pending',
  'Audit',
  'FinalConf',
]);

const sidebarNavScrollStyle = {
  maxHeight: 'calc(100vh - 170px)',
  overflowY: 'auto',
  overflowX: 'hidden',
};

export class Index extends Component {
  constructor(props) {
    super(props);
    this.user = JSON.parse(GetCookie('user'));

    let defaultTab = [];
    if (this.user.userrolename === 'Interpreter') {
      defaultTab = [
        {
          tabId: 'workorderint',
          tabTitle: 'Work Order (Int)',
          tabContent: <WorkOrderInt isMyJob={false} />,
        },
      ];
    } else {
      defaultTab = [
        {
          tabId: 'workorder',
          tabTitle: 'Work Order',
          tabContent: (
            <WorkOrder
              isMyJob={false}
              WorkFlowId=""
              TableView="default"
              hidePiggyback={hidePiggybackViews.has('Work Order')}
            />
          ),
        },
      ];
    }

    this.state = {
      activeTab:
        this.user.userrolename === 'Interpreter' ? 'workorderint' : 'workorder',
      tabList: defaultTab,
      isAccountingSectionOpen: true,
      isAdminSectionOpen: true,
    };

    this.addTab = this.addTab.bind(this);
    this.removeTab = this.removeTab.bind(this);
    this.toggleAccountingSection = this.toggleAccountingSection.bind(this);
    this.toggleAdminSection = this.toggleAdminSection.bind(this);
  }

  componentDidMount() {
    // ?tab=claimant lets the emailed-claimant page land the user on the Claimant list after saving.
    if (GetParameterByName('tab') === 'claimant') {
      this.addTab('claimant', 'Claimant', <Claimant initialClaimNumber={GetParameterByName('claimnumber') || ''} />);
    }

    const user = JSON.parse(Cookies.get('user'));
    if (user && user.token && user.userrolename !== 'Interpreter') {
      this.getRemoteTypes(user.token).then((rt) => {
        this.getRemoteHosts(user.token).then((rtH) => {
          this.getJobTypes(user.token).then((jt) => {
            this.getJobInvLineCode(user.token).then((tOT) => {
              this.getTimeOffType(user.token).then((tOU) => {
                this.getTimeOffUser(user.token).then((tOS) => {
                  this.getTimeOffStatus(user.token).then((jlc) => {
                    // Handle the fetched data as needed
                  });
                });
              });
            });
          });
        });
      });
    }
  }

  async getRemoteTypes(token) {
    await FetchData('/getjobinvlinecode', 'POST', token, {
      AppointmentTypeFlag: 2,
    }).then((data) => {
      localStorage.setItem('RemoteTypes', JSON.stringify(data));
    });
  }

  async getRemoteHosts(token) {
    await FetchData('/getjobinvlinecode', 'POST', token, {
      AppointmentTypeFlag: 3,
    }).then((data) => {
      localStorage.setItem('RemoteHosts', JSON.stringify(data));
    });
  }

  async getJobTypes(token) {
    await FetchData('/getjobinvlinecode', 'POST', token, {
      AppointmentTypeFlag: 1,
    }).then((data) => {
      localStorage.setItem('JobTypes', JSON.stringify(data));
    });
  }

  // get all the line codes needed for the Job Description
  async getJobInvLineCode(token) {
    await FetchData('/getjobinvlinecode', 'POST', token, {
      AppointmentTypeFlag: null,
    }).then((data) => {
      localStorage.setItem('JobInvLineCodes', JSON.stringify(data));
    });
  }

  async getTimeOffType(token) {
    await FetchData('/gettimeoffuser', 'POST', token).then((data) => {
      localStorage.setItem('TimeOffUsers', JSON.stringify(data));
    });
  }

  async getTimeOffUser(token) {
    await FetchData('/getlookups', 'POST', token, 'TimeOff.Type').then(
      (data) => {
        localStorage.setItem('TimeOffTypes', JSON.stringify(data));
      },
    );
  }

  async getTimeOffStatus(token) {
    await FetchData('/getlookups', 'POST', token, 'TimeOff.Status').then(
      (data) => {
        localStorage.setItem('TimeOffStatuses', JSON.stringify(data));
      },
    );
  }

  addTab(tabId, tabTitle, tabContent) {
    let tabs = [...this.state.tabList];

    const tabIndex = tabs.findIndex((obj) => obj.tabId === tabId);

    if (tabIndex === -1) {
      tabs.push({
        tabId,
        tabTitle,
        tabContent,
      });
    } else {
      tabs[tabIndex] = {
        tabId,
        tabTitle,
        tabContent,
      };
    }

    this.setState({
      tabList: tabs,
      activeTab: tabId,
    });
  }

  removeTab(tabId) {
    let tabs = [...this.state.tabList];

    var newTabList = tabs.filter(function (obj) {
      return obj.tabId !== tabId;
    });

    this.setState(
      {
        tabList: newTabList,
      },
      () => {
        if (this.state.tabList.length > 0) {
          this.setState({
            activeTab: this.state.tabList[0].tabId,
          });
        }
      },
    );
  }

  toggleAccountingSection() {
    this.setState((prevState) => ({
      isAccountingSectionOpen: !prevState.isAccountingSectionOpen,
    }));
  }

  toggleAdminSection() {
    this.setState((prevState) => ({
      isAdminSectionOpen: !prevState.isAdminSectionOpen,
    }));
  }

  renderInterpreterView() {
    return (
      <div>
        <div
          className="x-panel-body x-panel-body-default x-layout-fit x-panel-body-default"
          style={{ paddingLeft: '5px' }}
        >
          <WorkOrderInt isMyJob={false} />
        </div>
        <div style={{ paddingLeft: '10px', paddingTop: '10px' }}>
          <a href="/Interpreter_Confidentiality_Agreement.pdf" target="_blank" rel="noopener noreferrer">
            Confidentiality Agreement
          </a>
        </div>
      </div>
    );
  }

  renderSuperAdministratorView() {
    return (
      <div>
        <div>
          <div className="sidebar x-panel x-border-item x-box-item x-panel-default">
            <div className="x-panel x-autowidth-table x-grid-header-hidden x-panel-default x-tree-panel x-tree-lines x-grid">
              <span
                style={{
                  display: 'block',
                  padding: '0 6px 1px',
                  marginBottom: '10px',
                  fontWeight: 'bold',
                }}
              >
                Navigation
              </span>
              <div style={sidebarNavScrollStyle}>
                <Nav vertical>
                  <NavItem className="mb-2">
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'myjobs',
                          'My Jobs',
                          <WorkOrder
                            isMyJob={true}
                            TableView="myjobs"
                            WorkFlowId=""
                            CurrentUser={this.user.userid}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="My Jobs"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      My Jobs
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'workorder',
                          'Work Order',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId=""
                            TableView="default"
                            hidePiggyback={hidePiggybackViews.has('Work Order')}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Work Order"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Work Order
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('translation', 'Translation', <Translation />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Translation"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Translation
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'remote',
                          'Remote',
                          <WorkOrder
                            isMyJob={false}
                            TableView="remote"
                            hidePiggyback={hidePiggybackViews.has(
                              'Remote Jobs',
                            )}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Rem Type"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Remote Jobs
                    </NavLink>
                  </NavItem>
                  <NavItem className="mb-2">
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'CallBack',
                          'CallBack',
                          <WorkOrder isMyJob={false} TableView="callback" />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="CallBack"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      CallBacks
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'auth_transport',
                          'Auth/Transport',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId="Authorization"
                            TableView="auth_transport"
                            hidePiggyback={hidePiggybackViews.has(
                              'Auth/Transport',
                            )}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Auth/Transport"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Auth/Transport
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'booking',
                          'Booking',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId="Booking"
                            TableView="booking"
                            hidePiggyback={hidePiggybackViews.has('Booking')}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Booking"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Booking
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'confirmation',
                          'Confirmation',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId="Confirmation"
                            TableView="confirmation"
                            hidePiggyback={hidePiggybackViews.has(
                              'Confirmation',
                            )}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Booking"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Confirmation
                    </NavLink>
                  </NavItem>
                  <NavItem className="mb-2">
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'finalconf',
                          'FinalConf',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId=""
                            TableView="finalconf"
                            hidePiggyback={hidePiggybackViews.has('FinalConf')}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="FinalConf"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Final Confirmation
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('claimant', 'Claimant', <Claimant />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Claimant"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Claimant
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('client', 'Client', <Client />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Client"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Client
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'deletedjob',
                          'Deleted Jobs',
                          <WorkOrder isMyJob={false} TableView="deletedjobs" />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="DeletedJob"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Deleted Jobs
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'interpreter',
                          'Interpreter',
                          <Interpreter />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Interpreter"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Interpreter
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'intavailability',
                          'Interpreter Availability',
                          <InterpreterAvailabilityAdmin />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Interpreter Availability"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Interpreter Availability
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() => this.addTab('rep', 'Rep', <Rep />)}
                      className="menu-text"
                    >
                      <img
                        alt="Rep"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Rep
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'provideroffice',
                          'ProviderOffice',
                          <ProviderOffice />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="ProviderOffice"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Provider Office
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('rolodex', 'Rolodex', <Rolodex />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Rolodex"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Rolodex
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() => this.addTab('user', 'Users', <User />)}
                      className="menu-text"
                    >
                      <img
                        alt="User"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      User
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('timeoff', 'TimeOff', <TimeOff />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Time Off"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Time Off
                    </NavLink>
                  </NavItem>
                </Nav>
                <br />
                <span
                  style={{
                    paddingLeft: '12px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                  role="button"
                  tabIndex={0}
                  onClick={this.toggleAccountingSection}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.toggleAccountingSection();
                    }
                  }}
                >
                  {this.state.isAccountingSectionOpen ? '[-] ' : '[+] '}
                  Accounting
                </span>
                <Nav
                  vertical
                  style={{
                    display: this.state.isAccountingSectionOpen
                      ? 'block'
                      : 'none',
                  }}
                >
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'purplereport',
                          'PurpleReport',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId=""
                            TableView="purplereport"
                            hidePiggyback={hidePiggybackViews.has(
                              'PurpleReport',
                            )}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="PurpleReport"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      PurpleReport
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'pending',
                          'Pending',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId=""
                            TableView="pending"
                            hidePiggyback={hidePiggybackViews.has('Pending')}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Pending"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Pending
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'contract',
                          'Contract',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId=""
                            TableView="contract"
                            hidePiggyback={hidePiggybackViews.has('Contract')}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Contract"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Contract
                    </NavLink>
                  </NavItem>
                  <NavItem className="mb-2">
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'audit',
                          'Audit',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId=""
                            TableView="audit"
                            hidePiggyback={hidePiggybackViews.has('Audit')}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Audit"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Audit
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'accountsreceivable',
                          'Accounts Receivable',
                          <AccountsReceivable />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="AccountsReceivable"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Accounts Receivable
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'printinvoice',
                          'Print Invoice',
                          <PrintInvoice isMyJob={false} />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Print Invoices"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Print Invoices
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('postchecks', 'Post Checks', <PostChecks />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Post Checks"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Post Checks
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'transfer_cash',
                          'Transfer Cash',
                          <TransferCash />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Transfer Cash"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Transfer Cash
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'bulk_transfer',
                          'Bulk Transfer',
                          <BulkTransfer />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Bulk Transfer"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Bulk Transfer
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'late_invoices',
                          'Late Invoices',
                          <LateInvoices />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Late Invoices"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Late Invoices
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'InterpreterPayment',
                          'InterpreterPayment',
                          <InterpreterPayment />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Interpreter Payments"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Interpreter Payments
                    </NavLink>
                  </NavItem>
                </Nav>
                <br />
                <span
                  style={{
                    paddingLeft: '12px',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                  role="button"
                  tabIndex={0}
                  onClick={this.toggleAdminSection}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.toggleAdminSection();
                    }
                  }}
                >
                  {this.state.isAdminSectionOpen ? '[-] ' : '[+] '}Admin
                </span>
                <Nav
                  vertical
                  style={{
                    display: this.state.isAdminSectionOpen ? 'block' : 'none',
                  }}
                >
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'BusinessCards',
                          'BusinessCards',
                          <BusinessCards />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Business Cards"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Business Cards
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Production_Report',
                          'Production Report',
                          <RptProduction />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Production Report"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Production Report
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Client_Invoice_Summary',
                          'Client Invoice Summary',
                          <RptClientInvoiceSummary />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Client Summary"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Client Invoice Summary
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Accounts_Receivable',
                          'Accounts Receivable',
                          <RptAccountsReceivable />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Accounts Receivable"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Accounts Receivable
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Checks_Received',
                          'Checks Received',
                          <RptChecksReceived />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Checks Received"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Checks Received
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Interpreter1099',
                          'Interpreter 1099',
                          <RptInterpreter1099 />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Interpreter 1099"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Interpreter 1099
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('Rep_Count', 'Rep Count', <RptRepCount />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Rep Count"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Rep Count
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Client_Summary',
                          'Client Summary',
                          <RptClientSummary />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Client Summary"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Client Summary
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Transportation_Summary',
                          'Transportation Summary',
                          <RptTransportationSummary />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Transportation Summary"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Transportation Summary
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'Market_Report_Summary',
                          'Market Report Summary',
                          <RptMarketReportSummary />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Market Report Summary"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Market Report Summary
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'InterpreterSignups',
                          'Interpreter Signups',
                          <InterpreterSignUps />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Interpreter Signups"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Interpreter Signups
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'troubleticket',
                          'Trouble Tickets',
                          <TroubleTicket />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Trouble Tickets"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Trouble Tickets
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </div>
        </div>
        <div
          className="x-panel-body x-panel-body-default x-layout-fit x-panel-body-default"
          style={{ paddingLeft: '5px' }}
        >
          {this.state.tabList.length > 0 && (
            <div>
              <Nav tabs>
                {this.state.tabList.map((tabItem) => (
                  <NavItem key={tabItem.tabId}>
                    <NavLink
                      className={
                        this.state.activeTab === tabItem.tabId ? 'active' : ''
                      }
                      onClick={() => {
                        this.setState({ activeTab: tabItem.tabId });
                      }}
                    >
                      {tabItem.tabTitle} {'  '}{' '}
                      {this.user.userrolename !== 'Interpreter' && (
                        <img
                          src={RemoveIcon}
                          style={{
                            width: '13px',
                            height: '13px',
                            cursor: 'pointer',
                          }}
                          alt="Remove"
                          onClick={() => {
                            this.removeTab(tabItem.tabId);
                          }}
                        />
                      )}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              {this.state.tabList.map((tabItem) => (
                <TabContent
                  activeTab={this.state.activeTab}
                  key={tabItem.tabId}
                >
                  <TabPane tabId={tabItem.tabId}>
                    <Row>
                      <Col>{tabItem.tabContent}</Col>
                    </Row>
                  </TabPane>
                </TabContent>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSchedulerView() {
    return (
      <div>
        <div className="sidebar x-panel x-border-item x-box-item x-panel-default">
          <div className="x-panel x-autowidth-table x-grid-header-hidden x-panel-default x-tree-panel x-tree-lines x-grid">
            <span
              style={{
                display: 'block',
                padding: '0 6px 1px',
                marginBottom: '10px',
                fontWeight: 'bold',
              }}
            >
              Navigation
            </span>
            <div style={sidebarNavScrollStyle}>
              <Nav vertical>
                <NavItem className="mb-2">
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'myjobs',
                        'My Jobs',
                        <WorkOrder
                          isMyJob={true}
                          TableView="myjobs"
                          WorkFlowId=""
                          CurrentUser={this.user.userid}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="My Jobs"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    My Jobs
                  </NavLink>
                </NavItem>
                <NavItem>
                  {this.user.userrolename === 'Interpreter' ? (
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'workorderint',
                          'Work Order (Int)',
                          <WorkOrderInt />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Work Order"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Work Order (Int)
                    </NavLink>
                  ) : (
                    <NavLink
                      onClick={() =>
                        this.addTab(
                          'workorder',
                          'Work Order',
                          <WorkOrder
                            isMyJob={false}
                            WorkFlowId=""
                            TableView="default"
                            hidePiggyback={hidePiggybackViews.has('Work Order')}
                          />,
                        )
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Work Order"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Work Order
                    </NavLink>
                  )}
                </NavItem>
                {this.user.userrolename !== 'Interpreter' && (
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('translation', 'Translation', <Translation />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Translation"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Translation
                    </NavLink>
                  </NavItem>
                )}
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'remote',
                        'Remote',
                        <WorkOrder
                          isMyJob={false}
                          TableView="remote"
                          hidePiggyback={hidePiggybackViews.has('Remote Jobs')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Rem Type"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Remote Jobs
                  </NavLink>
                </NavItem>
                <NavItem className="mb-2">
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'CallBack',
                        'CallBack',
                        <WorkOrder isMyJob={false} TableView="callback" />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="CallBack"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    CallBacks
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'auth_transport',
                        'Auth/Transport',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId="Authorization"
                          TableView="auth_transport"
                          hidePiggyback={hidePiggybackViews.has(
                            'Auth/Transport',
                          )}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Auth/Transport"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Auth/Transport
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'booking',
                        'Booking',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId="Booking"
                          TableView="booking"
                          hidePiggyback={hidePiggybackViews.has('Booking')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Booking"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Booking
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'confirmation',
                        'Confirmation',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId="Confirmation"
                          TableView="confirmation"
                          hidePiggyback={hidePiggybackViews.has('Confirmation')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Booking"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Confirmation
                  </NavLink>
                </NavItem>
                <NavItem className="mb-2">
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'finalconf',
                        'FinalConf',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId=""
                          TableView="finalconf"
                          hidePiggyback={hidePiggybackViews.has('FinalConf')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="FinalConf"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Final Confirmation
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab('claimant', 'Claimant', <Claimant />)
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Claimant"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Claimant
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() => this.addTab('client', 'Client', <Client />)}
                    className="menu-text"
                  >
                    <img
                      alt="Client"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Client
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'deletedjob',
                        'Deleted Jobs',
                        <WorkOrder isMyJob={false} TableView="deletedjobs" />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="DeletedJob"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Deleted Jobs
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab('interpreter', 'Interpreter', <Interpreter />)
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Interpreter"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Interpreter
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'intavailability',
                        'Interpreter Availability',
                        <InterpreterAvailabilityAdmin />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Interpreter Availability"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Interpreter Availability
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'provideroffice',
                        'ProviderOffice',
                        <ProviderOffice />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="ProviderOffice"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Provider Office
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() => this.addTab('rep', 'Rep', <Rep />)}
                    className="menu-text"
                  >
                    <img
                      alt="Rep"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Rep
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab('rolodex', 'Rolodex', <Rolodex />)
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Rolodex"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Rolodex
                  </NavLink>
                  <NavItem>
                    <NavLink
                      onClick={() =>
                        this.addTab('timeoff', 'TimeOff', <TimeOff />)
                      }
                      className="menu-text"
                    >
                      <img
                        alt="Time Off"
                        src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        className="x-tree-icon x-tree-icon-leaf"
                      />{' '}
                      Time Off
                    </NavLink>
                  </NavItem>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'troubleticket',
                        'Trouble Tickets',
                        <TroubleTicket />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Trouble Tickets"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Trouble Tickets
                  </NavLink>
                </NavItem>
              </Nav>
              <br />
              <span
                style={{
                  paddingLeft: '12px',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
                role="button"
                tabIndex={0}
                onClick={this.toggleAccountingSection}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.toggleAccountingSection();
                  }
                }}
              >
                {this.state.isAccountingSectionOpen ? '[-] ' : '[+] '}
                Accounting
              </span>
              <Nav
                vertical
                style={{
                  display: this.state.isAccountingSectionOpen
                    ? 'block'
                    : 'none',
                }}
              >
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'purplereport',
                        'PurpleReport',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId=""
                          TableView="purplereport"
                          hidePiggyback={hidePiggybackViews.has('PurpleReport')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="PurpleReport"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    PurpleReport
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'pending',
                        'Pending',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId=""
                          TableView="pending"
                          hidePiggyback={hidePiggybackViews.has('Pending')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Pending"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Pending
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'contract',
                        'Contract',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId=""
                          TableView="contract"
                          hidePiggyback={hidePiggybackViews.has('Contract')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Contract"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Contract
                  </NavLink>
                </NavItem>
                <NavItem className="mb-2">
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'audit',
                        'Audit',
                        <WorkOrder
                          isMyJob={false}
                          WorkFlowId=""
                          TableView="audit"
                          hidePiggyback={hidePiggybackViews.has('Audit')}
                        />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Audit"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Audit
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'printinvoice',
                        'Print Invoice',
                        <PrintInvoice isMyJob={false} />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Print Invoices"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Print Invoices
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Accounts_Receivable',
                        'Accounts Receivable',
                        <RptAccountsReceivable />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Accounts Receivable"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Accounts Receivable
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab('postchecks', 'Post Checks', <PostChecks />)
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Post Checks"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Post Checks
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'transfer_cash',
                        'Transfer Cash',
                        <TransferCash />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Transfer Cash"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Transfer Cash
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'bulk_transfer',
                        'Bulk Transfer',
                        <BulkTransfer />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Bulk Transfer"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Bulk Transfer
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'late_invoices',
                        'Late Invoices',
                        <LateInvoices />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Late Invoices"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Late Invoices
                  </NavLink>
                </NavItem>
              </Nav>
              <br />
              <span
                style={{
                  paddingLeft: '12px',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
                role="button"
                tabIndex={0}
                onClick={this.toggleAdminSection}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.toggleAdminSection();
                  }
                }}
              >
                {this.state.isAdminSectionOpen ? '[-] ' : '[+] '}Admin
              </span>
              <Nav
                vertical
                style={{
                  display: this.state.isAdminSectionOpen ? 'block' : 'none',
                }}
              >
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'BusinessCards',
                        'BusinessCards',
                        <BusinessCards />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Business Cards"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Business Cards
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Production_Report',
                        'Production Report',
                        <RptProduction />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Production Report"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Production Report
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Client_Invoice_Summary',
                        'Client Invoice Summary',
                        <RptClientInvoiceSummary />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Client Summary"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Client Invoice Summary
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Accounts_Receivable',
                        'Accounts Receivable',
                        <RptAccountsReceivable />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Accounts Receivable"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Accounts Receivable
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Checks_Received',
                        'Checks Received',
                        <RptChecksReceived />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Checks Received"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Checks Received
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Interpreter1099',
                        'Interpreter 1099',
                        <RptInterpreter1099 />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Interpreter 1099"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Interpreter 1099
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab('Rep_Count', 'Rep Count', <RptRepCount />)
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Rep Count"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Rep Count
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Client_Summary',
                        'Client Summary',
                        <RptClientSummary />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Client Summary"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Client Summary
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'Transportation_Summary',
                        'Transportation Summary',
                        <RptTransportationSummary />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Transportation Summary"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Transportation Summary
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    onClick={() =>
                      this.addTab(
                        'InterpreterSignups',
                        'Interpreter Signups',
                        <InterpreterSignUps />,
                      )
                    }
                    className="menu-text"
                  >
                    <img
                      alt="Interpreter Signups"
                      src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      className="x-tree-icon x-tree-icon-leaf"
                    />{' '}
                    Interpreter Signups
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
        </div>

        <div
          className="x-panel-body x-panel-body-default x-layout-fit x-panel-body-default"
          style={{ paddingLeft: '5px' }}
        >
          {this.state.tabList.length > 0 && (
            <div>
              <Nav tabs>
                {this.state.tabList.map((tabItem) => (
                  <NavItem key={tabItem.tabId}>
                    <NavLink
                      className={
                        this.state.activeTab === tabItem.tabId ? 'active' : ''
                      }
                      onClick={() => {
                        this.setState({ activeTab: tabItem.tabId });
                      }}
                    >
                      {tabItem.tabTitle} {'  '}{' '}
                      {this.user.userrolename !== 'Interpreter' && (
                        <img
                          src={RemoveIcon}
                          style={{
                            width: '13px',
                            height: '13px',
                            cursor: 'pointer',
                          }}
                          alt="Remove"
                          onClick={() => {
                            this.removeTab(tabItem.tabId);
                          }}
                        />
                      )}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              {this.state.tabList.map((tabItem) => (
                <TabContent
                  activeTab={this.state.activeTab}
                  key={tabItem.tabId}
                >
                  <TabPane tabId={tabItem.tabId}>
                    <Row>
                      <Col>{tabItem.tabContent}</Col>
                    </Row>
                  </TabPane>
                </TabContent>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  /// <summary>
  /// Dynamically renders different types of work order tables based on the current table view state.
  /// This method checks if the component is in a loading state and displays a loading message if true.
  /// Otherwise, it selects the appropriate rendering function from a set of predefined functions based on the current table view type.
  /// If the table view type does not match any predefined types, it defaults to rendering the default work order table.
  /// </summary>
  /// <returns>
  /// Returns a JSX element representing the appropriate work order table or a loading indicator.
  /// </returns>
  renderContent() {
    let view = this.user.userrolename;
    if (view === 'Super Administrator' || view === 'Administrator') {
      view = 'SuperAdministrator';
    }

    const viewRenderers = {
      Interpreter: () => this.renderInterpreterView(),
      SuperAdministrator: () => this.renderSuperAdministratorView(),
      Scheduler: () => this.renderSchedulerView(),
    };
    return (viewRenderers[view] || viewRenderers['Scheduler'])();
  }

  render() {
    const contents = this.renderContent();
    // Special case for Interpreter users - directly render WorkOrderInt without tabs
    return contents;
  }
}
